<template>
  <div class="thisweekarrangeplan">
    <el-row v-show="buttonShow" class="row-title">
      <el-col :span="3" style="margin-right: 30px"><kt-button label="编辑本月计划" type="primary"
          @click="handleEditThisWeekPlan" /></el-col>
      <el-col :span="3" style="margin-right: 30px"><kt-button label="添加下月计划" type="primary"
          @click="handleAddNextWeekPlan" /></el-col>
      <el-col :span="3">
        <kt-button label="查看全部计划" type="primary" @click="handleLookAllPlan" />
      </el-col>
    </el-row>

    <el-row v-show="planShow" style="height: 54px; line-height: 54px">
      <el-col :span="6" style="display: flex;">
        <p style="margin-right: 10px;margin-left:10px">
          {{
            thisWeekArrangePlan.schedulingScheme
          }}
        </p>
        <el-select v-model="plan" style="width: 60%" @change="handleSelect" :disabled="planDisabled">
          <el-option v-for="item in planOptions" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-col>
    </el-row>

    <el-row v-show="dateShow" style="height: 54px; line-height: 54px">
      <el-col :span="2"><kt-button label="返回" type="primary" @click="dateBack" /></el-col>
      <el-col :span="2" align="right" style="margin-right: 5px"><kt-button label="上一月" type="primary"
          @click="handlePrevWeek" /></el-col>
      <el-col :span="4">
        <el-date-picker :editable="false" :clearable="false" v-model="dateValue" type="month"
          :placeholder="thisWeekArrangePlan.optionDate" value-format="yyyy-MM" format="yyyy-MM" @change="changeDate">
        </el-date-picker>
      </el-col>
      <el-col :span="2"><kt-button label="下一月" type="primary" @click="handleNextWeek" /></el-col>
    </el-row>

    <el-row style="
        height: 54px;
        line-height: 54px;
        background: #f9f7fa;
        border: 1px #f1eff2 solid;
        margin-top: 20px;
      ">
      <el-col :span="4" style="font-size: 18px">
        <img src="@/assets/beadhouse/juxing.png" alt="" style="vertical-align: middle; margin: 0 10px" />

        <span v-show="thisWeekPlanShow">{{
          thisWeekArrangePlan.thisMonSchedule
        }}</span>
        <span v-show="nextWeekPlanShow">{{
          thisWeekArrangePlan.nextMonSchedule
        }}</span>

        <span v-show="allPlanShow">{{ thisWeekArrangePlan.allSchedule }}</span>
      </el-col>
      <el-col :span="6" :offset="14" align="right"><span style="margin-right: 15px">{{ monthStr }}</span>
        <!-- <span style="margin-right: 15px">{{ whichWeekTo }}</span> -->
      </el-col>
    </el-row>
    <el-row style="width: 100%; overflow-x: auto">
      <table class="tables">
        <tr>
          <th class="tableth">
            <el-checkbox label="全选" v-show="isEditStatus" v-model="isAllChecked" @change="allSelectItem"></el-checkbox>
            <p v-show="!isEditStatus">日期</p>
          </th>
          <th class="tableth" v-for="(item, index) in daySelect" :key="index">
            <el-checkbox v-show="isEditStatus" :label="item.day" :value="item.check" :checked="item.check"
              @change="changeSelectItem(index)"></el-checkbox>
            <p v-show="!isEditStatus">{{ item.day }}</p>
          </th>
        </tr>
        <!-- for 班次 -->
        <tr style="height: 70px">
          <th class="tableth">
            {{ schemeCiName }}
          </th>
          <th class="tableth" @click="showChooseDialog(item)" v-for="(item, index) in schemeList" :key="index" style="
              padding: 15px 0px;
              box-sizing: border-box;
              font-size: 14px;
              font-weight: 400;
              line-height: 25px;
            ">
            {{ item.name }}
          </th>
        </tr>
        <tr v-show="!isEditStatus">
          <th class="tableth">{{ thisWeekArrangePlan.status }}</th>
          <th class="tableth" :colspan="daySelect.length">{{ status }}</th>
        </tr>
      </table>

      <div align="center" style="margin: 40px 0 50px 0" v-show="saveAndBackShow">
        <kt-button label="确定" type="primary" @click="submitPlan" />
        <kt-button label="返回" type="warning" @click="back" />
      </div>
    </el-row>

    <!-- 点击表格的单个单元格弹出dialog模态框-->
    <el-dialog :title="thisWeekArrangePlan.add" width="45%" :visible.sync="dialogVisibleAddNursing"
      :close-on-click-modal="false" @close="closeAddNursing">
      <el-form :model="addNursing" label-width="100px" :rules="addNursingRules" ref="addNursing" label-position="right">
        <el-row style="width: 80%; margin: 0 auto">
          <el-row style="
              height: 54px;
              line-height: 54px;
              border: 1px #f1eff2 solid;
              text-align: center;
              font-size: 16px;
            ">{{ thisWeekArrangePlan.careManagement }}</el-row>
          <el-row style="
              min-height: 100px;
              border: 1px #f1eff2 solid;
              border-top: none;
            ">
            <el-checkbox-group v-model="checkedNursing" @change="handleCheckedNursing"
              style="width: 65%; margin: 10px auto">
              <el-checkbox v-for="(nursing, i) in allNursing" :label="nursing.value" :key="i" style="margin-top: 10px">{{
                nursing.label }}</el-checkbox>
            </el-checkbox-group>
          </el-row>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button :size="size" @click.native="handleCancel">取消</el-button>
        <el-button :size="size" type="primary" @click.native="submitFormAddNursing">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import KtTable from "@/components/KtTable";
import KtButton from "@/components/KtButton";
import util from "@/utils/util.js";
export default {
  name: "ThisWeekArrangePlan",
  components: { KtTable, KtButton },
  data() {
    return {
      isMonitor: false, //是否是班长
      planDisabled: true, //排班方案下拉框是否禁用 true   false
      loading: false,
      isEditStatus: false, //是否可以编辑,处于编辑状态
      status: "", //审批状态
      schemeList: [], // 排班计划数据
      isAllChecked: false,
      nursingGroupId: "",
      monthStr: "",
      shemeId: "",
      schemeCiName: "24小时",
      currentScheme: {}, //当前排班计划;
      thisWeekArrangePlan: {
        which: "第",
        week: "周",
        to: "至",
        Monday: "周一",
        Tuesday: "周二",
        Wednesday: "周三",
        Thursday: "周四",
        Friday: "周五",
        Saturday: "周六",
        Sunday: "周日",
        editorThisWeekSchedule: "编辑本周排班",
        addNextWeekSchedule: "添加下周排班",
        viewAllPlans: "查看全部计划",
        schedulingScheme: "排班方案",
        optionDate: "选择日期",
        thisWeekSchedule: "本周排班计划",
        nextWeekSchedule: "下周排班计划",
        thisMonSchedule: "本月排班计划",
        nextMonSchedule: "下月排班计划",
        allSchedule: "所有排班计划",
        loading: "拼命加载中...",
        status: "状态",
        approvalPending: "待审批",
        add: "添加",
        careManagement: "护工列表",
        schedulingPlan: "排班计划",
        operation: "操作",
        confirmationInformation: "信息确认",
        noPassTitle: "你确定不通过排班计划吗?",
        reason: "原因",
        notEmpty: "不能为空",
        messageLen: "长度在 1到 50 的字符"
      }, //引入 lang 里面的字符串资源,
      week: "", //第几周
      whichWeekTo: "", //某某年月日到某某年月日
      daySelect: [],
      isTrue: false, //点击表格的单元格时是否有 hoverColor的样式属性
      cellClickWeek: "", //点击表格的单元格是星期几
      size: "medium", //按钮的尺寸
      dateShow: false,
      dateValue: util.formatDate.format(new Date(), "yyyy-MM-dd"),
      thisWeekPlanShow: true,
      nextWeekPlanShow: false,
      allPlanShow: false,
      buttonShow: true,
      planShow: false,
      plan: "", //排班方案下拉框的值
      planOptions: [],
      checkScheduleList: [], //用来判断本周的排班计划是否存在
      labelList: [],
      saveAndBackShow: false,
      //添加护工的dialog配置
      dialogVisibleAddNursing: false,
      addNursing: {},
      addNursingRules: {},
      addNursingLoading: false,
      checkedNursing: [], //被选中的护工集合
      allNursing: [], //所有护工的集合
      scheduls: [], //排班几划的集合
      checkUserId: "", //护工id拼接的字符串
      checkRealName: "", //护工名字的字符串拼接
      columnLabel: "", //table每一列的label
      rowShiftsId: "", //table每一行的shiftsId
      userNameArray: [], //点击填充表格的护工名数组
      rowIndex: "", //by guo 2019-12-09-17:15添加
      columnIndex: "", //by guo 2019-12-09-17:15添加
    };
  },
  methods: {
    allSelectItem() {
      console.log(this.isAllChecked);
      var dayCheckList = [];
      this.daySelect.forEach((item) => {
        dayCheckList.push({
          day: item.day,
          check: this.isAllChecked,
        });
      });
      this.daySelect = dayCheckList;
      console.log(this.daySelect);
    },
    changeSelectItem(index) {
      this.daySelect[index].check = !this.daySelect[index].check;
    },
    showChooseDialog(item) {
      if (this.isEditStatus) {
        console.log(item);
        console.log(this.daySelect);
        // daySelect
        // this.daySelect; 判断是否选中日期
        var isCheckDay = false;
        this.daySelect.forEach((item) => {
          if (item.check == true) {
            isCheckDay = true;
          }
        });
        if (isCheckDay) {
          this.dialogVisibleAddNursing = true;
          // 初始化check数据
          this.checkedNursing = [];
        } else {
          this.$message("请先选中日期");
        }
      }
    },
    /* 
      判断是否为班长 不是班长不能编辑 by xiang 2019-11-28
    */
    findIsMonitor() {
      this.$postForm("omc/group/getUserLongDetail").then((res) => {
        this.isMonitor = res.result.monitor;
        if (!this.isMonitor) {
          this.$message({
            message: "非班长用户不能编辑排班计划",
            type: "error",
          });
        }
      });
    },
    /* 
      编辑本月排班
    */
    handleEditThisWeekPlan() {
      var now = new Date();
      this.initDay(now.getFullYear(), now.getMonth() + 1); //查询本月天数
      //2.置为edit状态
      this.isEditStatus = true;
      //3.显示底部按钮
      this.saveAndBackShow = true;
      this.buttonShow = false;
      this.planShow = true;
      // 启用排班计划编辑
      this.planDisabled = false; // 如果本月没有排班计划通过审批的话
      // this.dateShow = true;
      this.queryThisMonPlan();
    },

    /*
            添加下月排班
        */
    handleAddNextWeekPlan() {
      var now = new Date();
      var month = now.getMonth() + 1;
      var year = now.getFullYear();
      if (month == 12) {
        month = 1;
        year = year + 1;
      } else {
        month = month + 1;
      }
      this.nextWeekPlanShow = true;
      this.thisWeekPlanShow = false;
      this.initDay(year, month); //查询本月天数
      //2.置为edit状态
      this.isEditStatus = true;
      //3.显示底部按钮
      this.saveAndBackShow = true;
      this.buttonShow = false;
      this.planShow = true;
      // 启用排班计划编辑
      this.planDisabled = false; // 如果本月没有排班计划通过审批的话
      // this.dateShow = true;
      this.queryThisMonPlan();
    },

    /* 
            查看全部计划
        */
    handleLookAllPlan() {
      this.allPlanShow = true;
      this.thisWeekPlanShow = false;
      this.nextWeekPlanShow = false;
      this.buttonShow = false;
      this.dateShow = true;
      this.isTrue = false;
      this.isEditStatus = false;
    },
    submitPlan() {
      //提交排班计划;
      console.log(this.schemeList);
      console.log(this.currentScheme);
      console.log(this.monthStr); //月
      if (this.currentScheme.shiftsId == "") {
        this.$message("请选择排班方案");
        return;
      }
      var submitForm = {
        shiftsId: this.currentScheme.shiftsId,
        planId: this.currentScheme.planId,
        month: this.monthStr,
        nursingGroupId: this.nursingGroupId,
        firstDay: this.monthStr + "-01",
        firstDayUserId: this.schemeList[0].idStr,
        firstDayRealName: this.schemeList[0].name,
        secondDay: this.monthStr + "-02",
        secondDayUserId: this.schemeList[1].idStr,
        secondDayRealName: this.schemeList[1].name,
        thirdDay: this.monthStr + "-03",
        thirdDayUserId: this.schemeList[2].idStr,
        thirdDayRealName: this.schemeList[2].name,
        fourthDay: this.monthStr + "-04",
        fourthDayUserId: this.schemeList[3].idStr,
        fourthDayRealName: this.schemeList[3].name,
        fifthDay: this.monthStr + "-05",
        fifthDayUserId: this.schemeList[4].idStr,
        fifthDayRealName: this.schemeList[4].name,
        sixthDay: this.monthStr + "-06",
        sixthDayUserId: this.schemeList[5].idStr,
        sixthDayRealName: this.schemeList[5].name,
        seventhDay: this.monthStr + "-07",
        seventhDayUserId: this.schemeList[6].idStr,
        seventhDayRealName: this.schemeList[6].name,
        eighthDay: this.monthStr + "-08",
        eighthDayUserId: this.schemeList[7].idStr,
        eighthDayRealName: this.schemeList[7].name,
        ninthDay: this.monthStr + "-09",
        ninthDayUserId: this.schemeList[8].idStr,
        ninthDayRealName: this.schemeList[8].name,
        tenthDay: this.monthStr + "-10",
        tenthDayUserId: this.schemeList[9].idStr,
        tenthDayRealName: this.schemeList[9].name,
        elevenDay: this.monthStr + "-11",
        elevenDayUserId: this.schemeList[10].idStr,
        elevenDayRealName: this.schemeList[10].name,
        twelveDay: this.monthStr + "-12",
        twelveDayUserId: this.schemeList[11].idStr,
        twelveDayRealName: this.schemeList[11].name,
        thirteenthDay: this.monthStr + "-13",
        thirteenthDayUserId: this.schemeList[12].idStr,
        thirteenthDayRealName: this.schemeList[12].name,
        fourteenthDay: this.monthStr + "-14",
        fourteenthDayUserId: this.schemeList[13].idStr,
        fourteenthDayRealName: this.schemeList[13].name,
        fifteenthDay: this.monthStr + "-15",
        fifteenthDayUserId: this.schemeList[14].idStr,
        fifteenthDayRealName: this.schemeList[14].name,
        sixteenthDay: this.monthStr + "-16",
        sixteenthDayUserId: this.schemeList[15].idStr,
        sixteenthDayRealName: this.schemeList[15].name,
        seventeenthDay: this.monthStr + "-17",
        seventeenthDayUserId: this.schemeList[16].idStr,
        seventeenthDayRealName: this.schemeList[16].name,
        eighteenthDay: this.monthStr + "-18",
        eighteenthDayUserId: this.schemeList[17].idStr,
        eighteenthDayRealName: this.schemeList[17].name,
        ninteenthDay: this.monthStr + "-19",
        ninteenthDayUserId: this.schemeList[18].idStr,
        ninteenthDayRealName: this.schemeList[18].name,
        twentythDay: this.monthStr + "-20",
        twentythDayUserId: this.schemeList[19].idStr,
        twentythDayRealName: this.schemeList[19].name,
        twentyFirstDay: this.monthStr + "-21",
        twentyFirstDayUserId: this.schemeList[20].idStr,
        twentyFirstDayRealName: this.schemeList[20].name,
        twentySecondDay: this.monthStr + "-22",
        twentySecondDayUserId: this.schemeList[21].idStr,
        twentySecondDayRealName: this.schemeList[21].name,
        twentyThirdDay: this.monthStr + "-23",
        twentyThirdDayUserId: this.schemeList[22].idStr,
        twentyThirdDayRealName: this.schemeList[22].name,
        twentyFourthDay: this.monthStr + "-24",
        twentyFourthDayUserId: this.schemeList[23].idStr,
        twentyFourthDayRealName: this.schemeList[23].name,
        twentyFifthDay: this.monthStr + "-25",
        twentyFifthDayUserId: this.schemeList[24].idStr,
        twentyFifthDayRealName: this.schemeList[24].name,
        twentySixthDay: this.monthStr + "-26",
        twentySixthDayUserId: this.schemeList[25].idStr,
        twentySixthDayRealName: this.schemeList[25].name,
        twentySeventhDay: this.monthStr + "-27",
        twentySeventhDayUserId: this.schemeList[26].idStr,
        twentySeventhDayRealName: this.schemeList[26].name,
        twentyEighthDay: this.monthStr + "-28",
        twentyEighthDayUserId: this.schemeList[27].idStr,
        twentyEighthDayRealName: this.schemeList[27].name,
      };
      if (this.schemeList.length > 28) {
        submitForm.twentyNinthDay = this.monthStr + "-29";
        submitForm.twentyNinthDayUserId = this.schemeList[28].idStr;
        submitForm.twentyNinthDayRealName = this.schemeList[28].name;
      }
      if (this.schemeList.length > 29) {
        submitForm.thirtiethDay = this.monthStr + "-30";
        submitForm.thirtiethDayUserId = this.schemeList[29].idStr;
        submitForm.thirtiethDayRealName = this.schemeList[29].name;
      }
      if (this.schemeList.length > 30) {
        submitForm.thirtyFirstDay = this.monthStr + "-31";
        submitForm.thirtyFirstDayUserId = this.schemeList[30].idStr;
        submitForm.thirtyFirstDayRealName = this.schemeList[30].name;
      }
      if (this.shemeId != "") {
        submitForm.id = this.shemeId;
      }

      console.log(submitForm);
      //omc/schedule/saveSchedulMonth
      //omc/plan/updateNewPlan
      this.$postJson("omc/schedule/saveSchedulMonth", submitForm).then(
        (res) => {
          console.log(res);
          //当前计划
          this.$message(res.message);
          if (res.code == 200) {
            this.back();
          }
        }
      );
    },
    /*
            全部计划的页面返回
        */
    dateBack() {
      //置为!edit状态
      this.isEditStatus = false;
      //提交数据后把所有的状态都初始化
      this.thisWeekPlanShow = true;
      this.isAllChecked = false;
      this.nextWeekPlanShow = false;
      this.allPlanShow = false;
      this.dateShow = false;
      this.buttonShow = true;
      this.planShow = false;
      this.saveAndBackShow = false;
      this.isTrue = false;
      this.labelList = []; //把数据清空
      var now = new Date();
      this.initDay(now.getFullYear(), now.getMonth() + 1); //查询本月天数
      this.queryThisMonPlan(); //查询本月排班计划
    },

    /*
      上一周
    */
    handlePrevWeek() {
      // this.monthStr;
      var yearMonth = this.monthStr;
      var year = yearMonth.split("-")[0];
      var month = yearMonth.split("-")[1];
      month = parseInt(month, 10);
      year = parseInt(year);
      if (month == 1) {
        month = 12;
        year = year - 1;
      } else {
        month = month - 1;
      }
      this.dateValue = year + "-" + month;
      this.nextWeekPlanShow = false;
      this.thisWeekPlanShow = false;
      this.initDay(year, month); //查询天数
      //2.置为edit状态
      this.isEditStatus = false;
      //3.显示底部按钮
      // this.saveAndBackShow = true;
      this.buttonShow = false;
      // this.planShow = true;
      // 启用排班计划编辑
      this.planDisabled = false; // 如果本月没有排班计划通过审批的话
      // this.dateShow = true;
      this.queryThisMonPlan();
    },

    /* 
            下一周
        */
    handleNextWeek() {
      var yearMonth = this.monthStr;
      var year = yearMonth.split("-")[0];
      var month = yearMonth.split("-")[1];
      year = parseInt(year);
      month = parseInt(month, 10);
      if (month == 12) {
        month = 1;
        year = year + 1;
      } else {
        month = month + 1;
      }
      this.dateValue = year + "-" + month;
      this.nextWeekPlanShow = false;
      this.thisWeekPlanShow = false;
      this.initDay(year, month); //查询天数
      //2.置为edit状态
      this.isEditStatus = false;
      //3.显示底部按钮
      // this.saveAndBackShow = true;
      this.buttonShow = false;
      // this.planShow = true;
      // 启用排班计划编辑
      this.planDisabled = false; // 如果本月没有排班计划通过审批的话
      // this.dateShow = true;
      this.queryThisMonPlan();
    },

    /* 
            点击时间查询 by xiang 
        */
    changeDate(val) {
      var year = val.split("-")[0];
      var month = val.split("-")[1];
      this.nextWeekPlanShow = false;
      this.thisWeekPlanShow = false;
      this.initDay(year, month); //查询天数
      //2.置为edit状态
      this.isEditStatus = false;
      //3.显示底部按钮
      // this.saveAndBackShow = true;
      this.buttonShow = false;
      // this.planShow = true;
      // 启用排班计划编辑
      this.planDisabled = false; // 如果本月没有排班计划通过审批的话
      // this.dateShow = true;
      this.queryThisMonPlan();
    },

    //多选框
    handleCheckedNursing(val) {
      console.log(val);
      this.checkedNursing = val;
    },
    /* 
      dialog取消关闭
    */
    handleCancel() {
      console.log(this.plan);
      this.checkedNursing = [];
      this.dialogVisibleAddNursing = false;
    },
    submitFormAddNursing() {
      this.dialogVisibleAddNursing = false;
      // 选中的护工 this.checkedNursing
      console.log(this.allNursing);
      console.log(this.checkedNursing);
      var checkNursingName = [];
      this.checkedNursing.forEach((item) => {
        this.allNursing.forEach((item2) => {
          if (item == item2.value) {
            checkNursingName.push({
              id: item,
              name: item2.label,
            });
          }
        });
      });
      console.log(checkNursingName);
      // 生成realname 和 idstr;

      var realName = "";
      var idStr = "";
      if (checkNursingName.length != 0) {
        checkNursingName.forEach((item) => {
          realName = realName + item.name + "-";
          idStr = idStr + item.id + "-";
        });
        realName = realName.substr(0, realName.length - 1);
        idStr = idStr.substr(0, idStr.length - 1);
      }
      console.log(realName);
      console.log(idStr);

      //选中的日期 this.daySelect
      //获取选中的日期列表
      // 循环这个
      // this.daySelect
      for (var i = 0; i < this.schemeList.length; i++) {
        if (this.daySelect[i].check) {
          this.schemeList[i].name = realName;
          this.schemeList[i].idStr = idStr;
          this.schemeList[i].user = this.checkedNursing;
        }
      }
      console.log(this.schemeList);
    },
    /* 
            返回按钮
        */
    back() {
      //置为!edit状态
      this.isEditStatus = false;
      //提交数据后把所有的状态都初始化
      this.thisWeekPlanShow = true;
      this.isAllChecked = false;
      this.nextWeekPlanShow = false;
      this.allPlanShow = false;
      this.buttonShow = true;
      this.planShow = false;
      this.saveAndBackShow = false;
      this.isTrue = false;
      this.labelList = []; //把数据清空
      var now = new Date();
      this.initDay(now.getFullYear(), now.getMonth() + 1); //查询本月天数
      this.queryThisMonPlan(); //查询本月排班计划
    },

    /* 
            排班方案下拉框
        */
    handleSelect(value) {
      console.log(value);
      this.plan = value; //获取排班计划的id by guo 2019-12-17-19:09添加
      this.getOnePlan(value);
    },

    /* 
            获取单个排班方案
        */
    getOnePlan(id) {
      console.log(id, "id---------");
      let params = {};
      params.id = id; //id传0时是查询所有的
      console.log(params, "传入的id是" + params.id);
      this.$postJson("omc/plan/queryListAll", params).then((res) => {
        console.log(res);
        //当前计划
        this.currentScheme = {
          planId: res.result[0].id,
          shiftsId: res.result[0].shiftsList[0].id,
        };
        this.shiftsList = res.result[0].shiftsList;
        //班次
        this.schemeCiName = res.result[0].shiftsList[0].name;
      });
    },
    closeAddNursing() { },
    /* 
     获取全部排班方案
    */
    getArrangePlan(id) {
      let params = {};
      params.id = id; //id传0时是查询所有的
      this.planOptions = []; //先清空数据，防止累加
      this.$postJson("omc/plan/queryListAll", params).then((res) => {
        console.log(res);
        var plan = res.result;
        for (var i = 0; i < plan.length; i++) {
          var item = {};
          item.value = plan[i].id * 1; //需要转成Number类型
          item.label = plan[i].name;
          this.planOptions.push(item); //排班方案下拉框的数据源
        }
        //判断一下 排班计划是否存在  存在才默认选中
        console.log(this.checkScheduleList, "-------------");
        if (
          this.checkScheduleList != null &&
          this.checkScheduleList.length > 0
        ) {
          //this.plan=plan[0].id;//排班方案select下拉框默认选中的值    //by guo 2019-8-13 19:21修改  有bug  不能默认选中第一个
        }
        console.log(this.planOptions, "this.planOptions");
      });
    },

    /* 
      查询对应护工组的护工
    */
    selectAllNurse() {
      let params = {};
      params.pageNo = "1";
      params.pageSize = "999";
      // params.nursingGroupId = this.nursingGroupId; //获取该护工组的护工
      console.log(params);
      this.allNursing = []; //请求数据之前先把数据置空
      this.$postJson("omc/group/selectNursingShowAll", params).then((res) => {
        console.log(res);
        if (res.code == 200) {
          res.result.forEach((item, index) => {
            console.log(item);
            var allNursingObj = {};
            allNursingObj.value = item.userId;
            allNursingObj.label = item.realName;
            this.allNursing.push(allNursingObj);
          });
        } else {
        }
      });
    },
    initDay(year, month) {
      // 1.获取当前月
      var dayNum = this.getDayFromMon(year, month);
      if (month < 10) {
        this.monthStr = year + "-0" + month;
      } else {
        this.monthStr = year + "-" + month;
      }
      var dayCheckList = [];
      for (var i = 1; i < dayNum + 1; i++) {
        dayCheckList.push({
          day: "" + i,
          check: false,
        });
      }
      this.daySelect = dayCheckList;
    },
    getDayFromMon(year, month) {
      month = parseInt(month, 10);
      var temp = new Date(year, month, 0);
      return temp.getDate();
    },
    queryThisMonPlan() {
      //查询本月是否有排班计划
      //有的话显示排班计划
      //没有的话 根据日期显示顶部,左侧不显示
      //根据权限显示编辑和添加

      //只会有一个班次
      this.schemeList = [];
      this.shemeId = "";
      //omc/schedule/getSchedulMonth
      this.$postJson("omc/schedule/getSchedulMonth", {
        month: this.monthStr,
        nursingGroupId: this.nursingGroupId,
      }).then((res) => {
        //这个计划的shemeId
        if (res.code == 200 && res.result.length != 0) {
          //有计划了;
          this.currentScheme = {
            planId: res.result[0].planId,
            shiftsId: res.result[0].omcShifts.id,
          };
          this.shemeId = res.result[0].id;
          this.plan = res.result[0].planId * 1;
          switch (res.result[0].status) {
            case 0:
              this.status = "未审批";
              break;
            case 1:
              this.status =
                " 审批不通过" + "          原因：" + res.result[0].reason;
              break;
            default:
              this.status = "审批通过";
          }
          this.schemeCiName = "24小时";
          if (res.result[0].omcShifts != null) {
            this.schemeCiName = res.result[0].omcShifts.name;
          }
          this.schemeList.push({
            name: res.result[0].firstDayRealName,
            user: res.result[0].firstDayUserId.split("-"),
            idStr: res.result[0].firstDayUserId,
          });
          this.schemeList.push({
            name: res.result[0].secondDayRealName,
            user: res.result[0].secondDayUserId.split("-"),
            idStr: res.result[0].secondDayUserId,
          });
          this.schemeList.push({
            name: res.result[0].thirdDayRealName,
            user: res.result[0].thirdDayUserId.split("-"),
            idStr: res.result[0].thirdDayUserId,
          });
          this.schemeList.push({
            name: res.result[0].fourthDayRealName,
            user: res.result[0].fourthDayUserId.split("-"),
            idStr: res.result[0].fourthDayUserId,
          });
          this.schemeList.push({
            name: res.result[0].fifthDayRealName,
            user: res.result[0].fifthDayUserId.split("-"),
            idStr: res.result[0].fifthDayUserId,
          });
          this.schemeList.push({
            name: res.result[0].sixthDayRealName,
            user: res.result[0].sixthDayUserId.split("-"),
            idStr: res.result[0].sixthDayUserId,
          });
          this.schemeList.push({
            name: res.result[0].seventhDayRealName,
            user: res.result[0].seventhDayUserId.split("-"),
            idStr: res.result[0].seventhDayUserId,
          });
          this.schemeList.push({
            name: res.result[0].eighthDayRealName,
            user: res.result[0].eighthDayUserId.split("-"),
            idStr: res.result[0].eighthDayUserId,
          });
          this.schemeList.push({
            name: res.result[0].ninthDayRealName,
            user: res.result[0].ninthDayUserId.split("-"),
            idStr: res.result[0].ninthDayUserId,
          });
          this.schemeList.push({
            name: res.result[0].tenthDayRealName,
            user: res.result[0].tenthDayUserId.split("-"),
            idStr: res.result[0].tenthDayUserId,
          });
          this.schemeList.push({
            name: res.result[0].elevenDayRealName,
            user: res.result[0].elevenDayUserId.split("-"),
            idStr: res.result[0].elevenDayUserId,
          });
          this.schemeList.push({
            name: res.result[0].twelveDayRealName,
            user: res.result[0].twelveDayUserId.split("-"),
            idStr: res.result[0].twelveDayUserId,
          });

          this.schemeList.push({
            name: res.result[0].thirteenthDayRealName,
            user: res.result[0].thirteenthDayUserId.split("-"),
            idStr: res.result[0].thirteenthDayUserId,
          });
          this.schemeList.push({
            name: res.result[0].fourteenthDayRealName,
            user: res.result[0].fourteenthDayUserId.split("-"),
            idStr: res.result[0].fourteenthDayUserId,
          });
          this.schemeList.push({
            name: res.result[0].fifteenthDayRealName,
            user: res.result[0].fifteenthDayUserId.split("-"),
            idStr: res.result[0].fifteenthDayUserId,
          });
          this.schemeList.push({
            name: res.result[0].sixteenthDayRealName,
            user: res.result[0].sixteenthDayUserId.split("-"),
            idStr: res.result[0].sixteenthDayUserId,
          });
          this.schemeList.push({
            name: res.result[0].seventeenthDayRealName,
            user: res.result[0].seventeenthDayUserId.split("-"),
            idStr: res.result[0].seventeenthDayUserId,
          });
          this.schemeList.push({
            name: res.result[0].eighteenthDayRealName,
            user: res.result[0].eighteenthDayUserId.split("-"),
            idStr: res.result[0].eighteenthDayUserId,
          });
          this.schemeList.push({
            name: res.result[0].ninteenthDayRealName,
            user: res.result[0].ninteenthDayUserId.split("-"),
            idStr: res.result[0].ninteenthDayUserId,
          });
          this.schemeList.push({
            name: res.result[0].twentythDayRealName,
            user: res.result[0].twentythDayUserId.split("-"),
            idStr: res.result[0].twentythDayUserId,
          });
          this.schemeList.push({
            name: res.result[0].twentyFirstDayRealName,
            user: res.result[0].twentyFirstDayUserId.split("-"),
            idStr: res.result[0].twentyFirstDayUserId,
          });
          this.schemeList.push({
            name: res.result[0].twentySecondDayRealName,
            user: res.result[0].twentySecondDayUserId.split("-"),
            idStr: res.result[0].twentySecondDayUserId,
          });
          this.schemeList.push({
            name: res.result[0].twentyThirdDayRealName,
            user: res.result[0].twentyThirdDayUserId.split("-"),
            idStr: res.result[0].twentyThirdDayUserId,
          });
          this.schemeList.push({
            name: res.result[0].twentyFourthDayRealName,
            user: res.result[0].twentyFourthDayUserId.split("-"),
            idStr: res.result[0].twentyFourthDayUserId,
          });
          this.schemeList.push({
            name: res.result[0].twentyFifthDayRealName,
            user: res.result[0].twentyFifthDayUserId.split("-"),
            idStr: res.result[0].twentyFifthDayUserId,
          });
          this.schemeList.push({
            name: res.result[0].twentySixthDayRealName,
            user: res.result[0].twentySixthDayUserId.split("-"),
            idStr: res.result[0].twentySixthDayUserId,
          });
          this.schemeList.push({
            name: res.result[0].twentySeventhDayRealName,
            user: res.result[0].twentySeventhDayUserId.split("-"),
            idStr: res.result[0].twentySeventhDayUserId,
          });
          this.schemeList.push({
            name: res.result[0].twentyEighthDayRealName,
            user: res.result[0].twentyEighthDayUserId.split("-"),
            idStr: res.result[0].twentyEighthDayUserId,
          });
          if (this.daySelect.length > 28) {
            this.schemeList.push({
              name: res.result[0].twentyNinthDayRealName,
              user: res.result[0].twentyNinthDayUserId.split("-"),
              idStr: res.result[0].twentyNinthDayUserId,
            });
          }
          if (this.daySelect.length > 29) {
            this.schemeList.push({
              name: res.result[0].thirtiethDayRealName,
              user: res.result[0].thirtiethDayUserId.split("-"),
              idStr: res.result[0].thirtiethDayUserId,
            });
          }
          if (this.daySelect.length > 30) {
            this.schemeList.push({
              name: res.result[0].thirtyFirstDayRealName,
              user: res.result[0].thirtyFirstDayUserId.split("-"),
              idStr: res.result[0].thirtyFirstDayUserId,
            });
          }
          console.log(this.schemeList);
        } else {
          this.currentScheme = {
            planId: "",
            shiftsId: "",
          };
          this.plan = "";
          this.status = "";
          this.schemeCiName = "24小时";
          this.daySelect.forEach((item) => {
            this.schemeList.push({
              name: "",
              user: [],
              idStr: "",
            });
          });
        }
      });
    },
  },
  created() {
    this.nursingGroupId = sessionStorage.getItem("nursingGroupId"); //获取护工组id
  },
  mounted() {
    var now = new Date();
    this.initDay(now.getFullYear(), now.getMonth() + 1); //查询本月天数
    this.queryThisMonPlan(); //查询本月排班计划
    // this.findIsMonitor(); //如果是班长,可以编辑,新增下个月
    this.selectAllNurse();
    this.getArrangePlan(0); // 获取全部排班计划;
  },
};
</script>
<style lang="scss" scoped>
.tables {
  width: 100%;
  border-collapse: collapse;
}

.tableth {
  width: 3%;
  height: 40px;
  min-width: 50px;
  background: white;
  border: 1px #9f9e9e solid;
}

.tables ::v-deep .el-checkbox__label {
  padding-left: 3px;
  font-size: 14px;
  text-align: center;
}

.thisweekarrangeplan {
  // min-width: 1360px;
  min-height: 500px;
  background: #fefefe;

  .hoverColor {
    // height:65px;
    //by guo 2019-10-30-17:11 修改  样式应该给一个最小的高度  让每一行 每一列里面的数据能够自适应高度
    min-height: 40px;
    line-height: 20px;
  }

  .hoverColor:hover {
    background: rgb(153, 176, 206);
    cursor: pointer;
  }

  .status {
    width: 100%;
    height: 65px;
    border: 1px solid #ebeef5;
    border-top: none;
    box-sizing: border-box;

    .status-left {
      width: 204px;
      height: 65px;
      line-height: 65px;
      text-align: center;
      border-right: 1px solid #ebeef5;
      float: left;
    }

    .status-right {
      float: right;
      height: 65px;
      width: 1100px;
      max-width: 1154px;
      line-height: 65px;
      text-align: center;
    }
  }
}

//去除表格hover高亮
::v-deep .el-table--enable-row-hover .el-table__body tr:hover>td {
  background-color: #ffffff !important;
}

::v-deep .el-table .el-table__body td {
  padding: 0px !important;
}

::v-deep .el-table .cell {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
</style>
